import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES, prefix } from './utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from '../../Global/form';

export const ProductsExecSummary: FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.products.title')}
          section={FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.mainProducts')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
      >
        {/* 1.3.1 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.mainProducts"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.productsValue')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE)}
      >
        {/* 1.3.2 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.productsValue"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.competitionAdvantage')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
      >
        {/* 1.3.3 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.competitionAdvantage"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.plans')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS)}
      >
        {/* 1.3.4 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.plans"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
